// src/components/Loading.tsx
import React from 'react';
import LoadingContext from "./loading.context.tsx";
import CustomPopup from "../../components/CustomPopup";
import './loading.css'

const Loading = () => {
    const {loadingState} = React.useContext(LoadingContext);
    //
    // if (!loadingState.show) return null;

    return (
        <CustomPopup isOpen={loadingState.show} hideMask={true}>
            <div className="loading-content-container">
                <div className="loading-icon" />
                <div className="my-roboto-regular">{loadingState.content ?? 'Loading...'}</div>
            </div>
        </CustomPopup>
    );
};

export default Loading;